// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: generic_task.proto

export const protobufPackage = 'compasspb';

/**
 * GenericTaskStatus represents the current state of a generic task in its lifecycle.
 * Tasks progress from scheduled through in-progress to either completed or failed status.
 */
export enum GenericTaskStatus {
  /** GENERIC_TASK_STATUS_UNSPECIFIED - Default/unknown status */
  GENERIC_TASK_STATUS_UNSPECIFIED = 0,
  /** GENERIC_TASK_STATUS_SCHEDULED - Task is scheduled but not yet started */
  GENERIC_TASK_STATUS_SCHEDULED = 1,
  /** GENERIC_TASK_STATUS_IN_PROGRESS - Task execution is currently in progress */
  GENERIC_TASK_STATUS_IN_PROGRESS = 2,
  /** GENERIC_TASK_STATUS_COMPLETED - Task completed successfully */
  GENERIC_TASK_STATUS_COMPLETED = 3,
  /** GENERIC_TASK_STATUS_FAILED - Task execution failed with an error */
  GENERIC_TASK_STATUS_FAILED = 4,
}

/** GenericTaskType represents the type of a generic task. */
export enum GenericTaskType {
  /** GENERIC_TASK_TYPE_UNSPECIFIED - Default/unknown type */
  GENERIC_TASK_TYPE_UNSPECIFIED = 0,
  /** GENERIC_TASK_TYPE_GASTRO_CREATE_TASK - Gastro create task */
  GENERIC_TASK_TYPE_GASTRO_CREATE_TASK = 1,
  /** GENERIC_TASK_TYPE_GASTRO_FAX_UPDATE_DESCRIPTION_TASK - Gastro fax update description task */
  GENERIC_TASK_TYPE_GASTRO_FAX_UPDATE_DESCRIPTION_TASK = 2,
  /** GENERIC_TASK_TYPE_GASTRO_FAX_FILING_TASK - Gastro fax filing task */
  GENERIC_TASK_TYPE_GASTRO_FAX_FILING_TASK = 3,
  /** GENERIC_TASK_TYPE_GASTRO_UPDATE_INELIGIBILITY_NOTE_TASK - Gastro update ineligibility note task */
  GENERIC_TASK_TYPE_GASTRO_UPDATE_INELIGIBILITY_NOTE_TASK = 4,
  /** GENERIC_TASK_TYPE_GASTRO_CREATE_NEW_PATIENT_TASK - Gastro create new patient task */
  GENERIC_TASK_TYPE_GASTRO_CREATE_NEW_PATIENT_TASK = 5,
  /** GENERIC_TASK_TYPE_PQC_PORTAL_FILLING_TASK - PQC portal filling task for tracking Browserbase portal session lifecycle */
  GENERIC_TASK_TYPE_PQC_PORTAL_FILLING_TASK = 6,
  /** GENERIC_TASK_TYPE_CARETEND_PROGRESS_NOTE - Refill: write one CareTend progress note (jnj-flows) */
  GENERIC_TASK_TYPE_CARETEND_PROGRESS_NOTE = 7,
  /** GENERIC_TASK_TYPE_CARETEND_DELIVERY_TICKET - Refill: create one CareTend delivery ticket (jnj-flows) */
  GENERIC_TASK_TYPE_CARETEND_DELIVERY_TICKET = 8,
}

/**
 * GenericTask represents a workflow-independent work item that can be assigned
 * to users and tracked through completion. Generic tasks are associated with
 * case records and support various task types with flexible input/output data.
 */
export interface GenericTask {
  id?: string | undefined;
  case_id?: string | undefined;
  input?: { [key: string]: any } | undefined;
  output?: { [key: string]: any } | undefined;
  type?: GenericTaskType | undefined;
  status?: GenericTaskStatus | undefined;
  error?: string | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
}

/**
 * CreateGenericTaskRequest contains the parameters needed to create a new generic task.
 * The task is associated with a specific case record and includes input data
 * and a task type that determines the task's behavior.
 */
export interface CreateGenericTaskRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  input?: { [key: string]: any } | undefined;
  type?: GenericTaskType | undefined;
}

/**
 * CreateGenericTaskResponse contains the details of the newly created generic task.
 * Returns the complete task object with generated ID, timestamps, and initial status.
 */
export interface CreateGenericTaskResponse {
  id?: string | undefined;
  case_id?: string | undefined;
  input?: { [key: string]: any } | undefined;
  output?: { [key: string]: any } | undefined;
  type?: GenericTaskType | undefined;
  status?: GenericTaskStatus | undefined;
  error?: string | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
}

/**
 * UpdateGenericTaskRequest contains the parameters to update an existing generic task.
 * Allows modification of input/output data, status, and error messages.
 * Only provided fields will be updated (partial update semantics).
 */
export interface UpdateGenericTaskRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  generic_task_id?: string | undefined;
  input?: { [key: string]: any } | undefined;
  output?: { [key: string]: any } | undefined;
  status?: string | undefined;
  error?: string | undefined;
}

/**
 * UpdateGenericTaskResponse contains the updated generic task details.
 * Returns the complete task object with all updated fields and timestamps.
 */
export interface UpdateGenericTaskResponse {
  task?: GenericTask | undefined;
}

/**
 * GetGenericTaskRequest contains the identifiers needed to retrieve a specific generic task.
 * Requires the organization, program, case record, and task IDs to locate the task.
 */
export interface GetGenericTaskRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  generic_task_id?: string | undefined;
}

/**
 * GetGenericTaskResponse contains the requested generic task details.
 * Returns the complete task object with current status and all associated data.
 */
export interface GetGenericTaskResponse {
  task?: GenericTask | undefined;
}

/**
 * GetGenericTasksRequest contains the parameters to retrieve all generic tasks for a case record.
 * Supports pagination through the limit parameter to control the number of returned tasks.
 * Supports filtering by task type through the optional type parameter.
 */
export interface GetGenericTasksRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  limit?: number | undefined;
  type?: GenericTaskType | undefined;
}

/**
 * GetGenericTasksResponse contains the list of generic tasks for the requested case record.
 * Returns all tasks associated with the case record, up to the specified limit.
 */
export interface GetGenericTasksResponse {
  tasks?: GenericTask[] | undefined;
}

/**
 * GenericTaskService provides operations for managing generic tasks.
 * Generic tasks are workflow-independent work items that can be assigned
 * to users and tracked through completion. They are associated with case
 * records and support various statuses including scheduled, in progress,
 * completed, and failed.
 */
export interface GenericTaskService {
  /**
   * CreateGenericTask creates a new generic task for a case record.
   * The task can be assigned to specific users and includes metadata
   * such as title, description, due dates, and priority.
   */
  createGenericTask(request: CreateGenericTaskRequest): Promise<CreateGenericTaskResponse>;
  /**
   * UpdateGenericTask updates an existing generic task.
   * This allows modification of task properties such as status, assignees,
   * due dates, and other metadata.
   */
  updateGenericTask(request: UpdateGenericTaskRequest): Promise<UpdateGenericTaskResponse>;
  /**
   * GetGenericTask retrieves a specific generic task by its ID.
   * Returns detailed information about the task including its current status,
   * assignees, and all associated metadata.
   */
  getGenericTask(request: GetGenericTaskRequest): Promise<GetGenericTaskResponse>;
  /**
   * GetGenericTasks retrieves all generic tasks for a specific case record.
   * Returns a list of all tasks associated with the case record, which can
   * be filtered or sorted based on various criteria.
   */
  getGenericTasks(request: GetGenericTasksRequest): Promise<GetGenericTasksResponse>;
}
